import React, { useEffect, useState } from "react";
import {
  Box, Button, Dialog, DialogActions, DialogContent,
  DialogTitle, IconButton, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, TextField, Typography, Paper,
  Popover
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import { getUnits, createUnit, updateUnit, deleteUnit } from "../../../Services/Services";

const UnitManager = () => {
  const [units, setUnits] = useState([]);
  const [unitForm, setUnitForm] = useState({ name: "", symbol: "", created_by: localStorage.getItem('user_id') });
  const [editId, setEditId] = useState(null);
  const [open, setOpen] = useState(false);

  // Popover state for delete confirmation
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const userId = localStorage.getItem('user_id');

  const fetchUnits = async () => setUnits(await getUnits());

  useEffect(() => {
    fetchUnits();
  }, []);

  const handleSave = async () => {
    if (editId) {
      await updateUnit(editId, unitForm);
    } else {
      await createUnit(unitForm);
    }
    setUnitForm({ name: "", symbol: "", created_by: userId });
    setEditId(null);
    fetchUnits();
  };



  const handlePopoverClose = () => {
    setAnchorEl(null);
    setDeleteId(null);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      await deleteUnit(deleteId);
      fetchUnits();
      handlePopoverClose();
    }
  };

  const openPopover = Boolean(anchorEl);

  return (
    <Box>
      <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>
        Unit
      </Button>

      <Dialog open={open} onClose={() => {
        setOpen(false);
        setEditId(null);
        setUnitForm({ name: "", symbol: "" });
      }} fullWidth maxWidth="md">
        <DialogTitle>Manage Units</DialogTitle>
        <DialogContent dividers>
          {/* Add/Edit Form */}
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
              label="Unit Name" fullWidth
              value={unitForm.name}
              onChange={(e) => setUnitForm({ ...unitForm, name: e.target.value })}
            />
            <TextField
              label="Symbol" fullWidth
              value={unitForm.symbol}
              onChange={(e) => setUnitForm({ ...unitForm, symbol: e.target.value })}
            />
            <Button variant="contained" onClick={handleSave}>
              {editId ? "Update" : "Add"}
            </Button>
          </Box>

          
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpen(false);
            setEditId(null);
            setUnitForm({ name: "", symbol: "" });
          }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Popover */}
      <Popover
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2, maxWidth: 220 }}>
          <Typography>Are you sure ?</Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
            <Button color="error" size="small" onClick={confirmDelete}>
              Yes
            </Button>
            <Button  size="small" onClick={handlePopoverClose}>
              No
            </Button>
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default UnitManager;